import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UsersService } from '../../services/users.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  type: 'login' | 'reset';
  loading = false;
  serverMessage: string;

  constructor(private afAuth: AngularFireAuth, private fb: FormBuilder, private router: Router, private userService: UsersService) { }

  ngOnInit() {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.minLength(6), Validators.required]]
    });
  }

  changeType(val) {
    this.type = val;
  }

  get isLogin() {
    return this.type === 'login';
  }

  get isPasswordReset() {
    return this.type === 'reset';
  }

  get email() {
    return this.form.get('email');
  }

  get password() {
    return this.form.get('password');
  }

  get passwordConfirm() {
    return this.form.get('passwordConfirm');
  }

  // get passwordDoesMatch() {
  //   if (this.type !== 'signup') {
  //     return true;
  //   } else {
  //     return this.password.value === this.passwordConfirm.value;
  //   }
  // }

  async onSubmit() {
    this.loading = true;

    const email = this.email.value;
    const password = this.password.value;

    try {

      if (this.isPasswordReset) {
        // console.log(this.type)
        await this.afAuth.sendPasswordResetEmail(email);
        this.serverMessage = 'Please check your email in order to reset your password';
      }


      // console.log(this.type)
      if (email === 'malini@link2future.ca' && password === 'link2futurepassword!') {
        await this.afAuth.signInWithEmailAndPassword(email, password);
        this.router.navigate(['/dashboard/home']);
      }
      await this.afAuth.signInWithEmailAndPassword(email, password);


    } catch (err) {
      this.serverMessage = err
    }

    this.loading = false;
  }

}
